module.exports = __webpack_public_path__ + "static/img/offline_rs.ea9fddb5.png";